module.exports = __webpack_public_path__ + "img/20200418112949TIM截图20200418111711.f5d7ace4.png";